<app-residential-question [questions] = "questions"></app-residential-question>
